module.exports = __webpack_public_path__ + "static/media/free-4.c788b3d6.jpg";